import { render } from "./SecureImage.vue?vue&type=template&id=64b08d91"
import script from "./SecureImage.vue?vue&type=script&lang=js"
export * from "./SecureImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__